export default "__VITE_ASSET__SJWKFBoB__"